<template>
  <div class="row">
    <div class="col-md-6">
      <div class="m-5">
        <div>
          <h5 class="text-capitalize" v-if="pasosAn1">{{ pasosAn1.modelo.dt1 | minusculas }} {{ anio }}</h5>
          <h6 class="text-capitalize text-muted" v-if="pasosAn2.color.dt1">{{ pasosAn2.color.dt1 | minusculas }}</h6>
        </div>
        <table class="mt-3">
          <tbody>
          <template v-for="item in lista">
            <tr class="bg-secondary" :key="item.label" v-if="listar(item).length">
              <td colspan="3">
                <h6 class="p-2 bg-secondary label-table">{{ item.label }}</h6>
              </td>
            </tr>
            <template v-if="listar(item).length" >
              <tr v-for="(i,ii) in listar(item)" :key="ii+item.label" >
                <td>
                  <h6>{{ i[item.dtoDetail] }}</h6>
                </td>
                <td class="pl-5 text-right">
                  <h6 class="precio-syb">{{ i[item.dtoNumber] | puntos }}</h6>
                </td>
                <td>
                  <h6 class="bton" v-if="item.canDelete" v-on:click="eliminar(i,item)">
                    <i class="fa fa-minus-circle"></i>
                  </h6>
                </td>
              </tr>
            </template>
            <tr  :key="item.label+'-tot'" v-if="listar(item).length">
              <td class="sum-total">
                <h6 class="mb-3 ">
                  <b>{{ item.totalLabel }}</b>
                </h6>
              </td>
              <td class="pl-5 text-right sum-total">
                <h6 class="mb-3 precio-syb font-weight-bold">{{ suma3(item.dtoNumber,listar(item)) | puntos }}</h6>
              </td>
            </tr>
          </template>
          <tr>
            <td>
              <h5 class="p-2 bg-dark text-white label-table">
                <b>Precio total del vehículo</b>
              </h5>
            </td>
            <td>
              <h5 class="p-2 bg-dark text-white label-table text-right precio-syb">
                <b>{{ sumaTotal | puntos }}</b>
              </h5>
            </td>
            <td>
              <h5 class="p-2 bg-dark text-white label-table">&nbsp;</h5>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="col-md-6">
      <imagen :cargando="false" :activo360="false" :activar="false"></imagen>
    </div>
  </div>
</template>

<script>
import constantes from "../../constantes";
import imagen from "../Paso2/Imagen/imagen-vehiculo";

export default {
  name: "resumen-componente",
  components: {
    imagen,
  },
  data:()=>({
    lista:[
      {
        label: "Paquetes",
        totalLabel: "Precio del vehículo",
        paso: 3,
        array: 'resumen',
        subArray: null,
        dtoNumber: "ndt1",
        dtoDetail: "dt1",
        canDelete: false,
      },
      {
        id:'ndt1',
        label: "Accesorios individuales",
        totalLabel: "Precio de individuales",
        paso: 2,
        array: 'accesorios',
        subArray: 'individuales',
        dtoNumber: "ndt2",
        dtoDetail: "dt2",
        canDelete: true,
      },
      {
        id:'ndt1',
        label: "Kit de accesorios",
        totalLabel: "Precio de kits",
        paso: 2,
        array: 'accesorios',
        subArray: 'kit',
        dtoNumber: "ndt2",
        dtoDetail: "dt2",
        canDelete: true,
      },
      {
        id:'id',
        label: "Mantenimientos prepagados",
        totalLabel: "Precio de mantenimientos",
        paso: 2,
        array: 'accesorios',
        subArray: 'cupones',
        dtoNumber: "ndt3",
        dtoDetail: "dt1",
        canDelete: true,
      },
    ]
  }),
  computed: {
    anio: function () {
      return this.$store.getters.getPasos[2].version.ndt10;
    },
    pasosAn1: function () {
      return this.$store.getters.getPasos[1];
    },
    pasosAn2: function () {
      return this.$store.getters.getPasos[2];
    },
    sumaTotal: function (){
      let suma = 0;
      this.lista.forEach(i=>{
        suma+=this.suma3(i.dtoNumber,this.listar(i))
      });
      return suma;
    },
  },
  filters:{
    minusculas: (dato) => constantes.funciones.minusculas(dato),
    puntos: (numero) => constantes.funciones.puntoMilesDecimal(numero),
  },
  methods: {
    suma: (vector) => constantes.funciones.sumar(vector),
    suma2: (vector1, vector2) => constantes.funciones.sumar2(vector1, vector2),
    suma3: (key, vector) => constantes.funciones.sumar3(key, vector),
    listar: function (item){
      const paso = this.$store.getters.getPasos[item.paso]
      if(item.subArray){
        return paso[item.array][item.subArray];
      }else{
        return paso[item.array];
      }
    },
    eliminar: function (elemento,objeto) {
      let vm = this;
      this.$swal({
        title: `<p>Quieres quitar <b>${elemento.dt2}</b> de tu lista?</p>`,
        type: 'info',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: true,
        confirmButtonText:
            '<i class="fa fa-thumbs-up"></i> No',
        confirmButtonAriaLabel: 'No',
        cancelButtonText:
            '<i class="fa fa-thumbs-down"></i> Si',
        cancelButtonAriaLabel: 'Si',
      }).then(function (valor) {
        if (valor.dismiss === "cancel") {
          vm.eliminarItem(elemento,objeto);
        }
      });
    },
    eliminarItem: function (elemento,objeto) {

      this.$store.commit('eliminarAc', {item:elemento,obj:objeto});
    }
  }
}
</script>

<style scoped>
.precio-syb::before {
  vertical-align: super;
  font-size: 0.55em;
  content: '$';
}

.sin-pad {
  padding: 0px;
}
td>h6 i{
  margin: 0;
}
.label-table{
  margin: -1px -0.5em -1px -0.5em;
}
</style>
